module.exports = __webpack_public_path__ + "static/media/review_1.c2cde2f0.jpg";